import { memo } from 'react';
import { Link, cn } from '@divlab/divanui';
import { IconChevronBottom } from '@divlab/divanui/icons';

import styles from './MenuTabHead.module.css';

import type { FC, HTMLAttributes, MouseEvent } from 'react';

export interface MenuTabHeadProps extends Omit<HTMLAttributes<HTMLDivElement>, 'onClick'> {
  className?: string;
  tab?: string;
  isProducts?: boolean;
  linkTo?: string;
  seeAll?: string;
  onClick?: (e: MouseEvent<HTMLDivElement | HTMLButtonElement>, tab: string) => void;
  selectedTab?: string;
}

const MenuTabHead: FC<MenuTabHeadProps> = (props) => {
  const { className, tab, isProducts, linkTo, seeAll, onClick, selectedTab, ...restProps } = props;

  return (
    <div
      {...restProps}
      className={cn(
        styles.head,
        {
          [styles.selected]: selectedTab === tab,
        },
        className,
      )}
    >
      <div className={styles.dropdown}>
        <div className={styles.toggle} onClick={(e) => onClick(e, tab)}>
          <div className={styles.title}>{tab}</div>

          <div className={styles.right}>
            <IconChevronBottom className={styles.arrow} />
          </div>
        </div>
        {isProducts && (
          <Link
            data-testid='showroom-item-all'
            className={styles.sellAll}
            to={linkTo}
            target='_blanq'
            rel='noopener'
          >
            <div className={styles.titleSeeAll}>{seeAll}</div>
            <div className={styles.right}>
              <IconChevronBottom className={styles.arrowSeeAll} />
            </div>
          </Link>
        )}
      </div>
    </div>
  );
};

export default memo(MenuTabHead);
